import { produce } from 'immer'
import { ActionType, getType } from 'typesafe-actions'

import { fetchCleanByIdAction, fetchCleansAction } from '../cleans/actions'
import { fetchTicketByIdAction } from '../tickets/actions'
import { fetchUnitByIdAction } from '../units/actions'
import { fetchVisitByIdAction, fetchVisitsAction } from '../visits/actions'
import { fetchReservationByIdAction } from './actions/fetchReservationById'
import { ReservationsState } from './reservations.types'
import { emptyNormalizedReservationsData } from './reservations.utils'

export const initialState: ReservationsState = {
  data: {},
}

const actions = {
  fetchCleanByIdAction,
  fetchCleansAction,
  fetchReservationByIdAction,
  fetchTicketByIdAction,
  fetchUnitByIdAction,
  fetchVisitByIdAction,
  fetchVisitsAction,
}

type Actions = ActionType<typeof actions>

export const reservationsReducer = (
  state = initialState,
  action: Actions,
): ReservationsState =>
  produce(state, (draft: ReservationsState) => {
    switch (action.type) {
      case getType(fetchCleanByIdAction.success):
      case getType(fetchCleansAction.success):
      case getType(fetchUnitByIdAction.success):
      case getType(fetchVisitByIdAction.success):
      case getType(fetchVisitsAction.success):
      case getType(fetchReservationByIdAction.success):
      case getType(fetchTicketByIdAction.success): {
        const normalized =
          action.payload?.normalized || emptyNormalizedReservationsData

        draft.data = {
          ...state.data,
          ...normalized.reservation,
        }

        return
      }
    }
  })
